var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "page-editor-ui": "static-1.29020",
      "apollo-dlb": "static-3.41",
      "backbone": "static-1.6",
      "codemirror-dlb": "static-1.50353",
      "collaboration-sidebar": "static-1.49356",
      "ContentComponents": "static-2.63753",
      "ContentData": "static-1.60871",
      "ContentEditorUI": "static-2.68801",
      "ContentUtils": "static-1.60794",
      "data-fetching-client": "static-1.7421",
      "editor-components": "static-1.10783",
      "emoji-mart": "static-3.4",
      "FileManagerLib": "static-1.31605",
      "foundations-assets": "static-1.2935",
      "foundations-components": "static-1.4933",
      "head-dlb": "static-1.3106",
      "hs-test-utils": "static-1.5984",
      "hub-http": "static-1.4150",
      "hub-http-shared-msw-handlers": "static-1.6032",
      "hubspot-dlb": "static-2.778",
      "HubStyleTokens": "static-2.9490",
      "I18n": "static-7.1324",
      "InpageEditorUI": "static-1.77247",
      "jasmine-immutable": "static-1.1029",
      "jasmine-runner": "static-1.4339",
      "layout-dnd-utils": "static-1.8729",
      "marketing-discovery-utils": "static-1.1776",
      "quartz": "static-1.4670",
      "react-dlb": "static-1.45",
      "react-dnd": "static-4.38",
      "react-dnd-html5-backend": "static-4.5",
      "react-redux": "static-7.16",
      "react-router-dom": "static-5.26",
      "react-utils": "static-2.3657",
      "redux-thunk": "static-2.17",
      "settings-ui-lib": "static-1.10531",
      "sinon": "static-1.9",
      "tinymce": "static-6.5",
      "ui-addon-draggable": "static-1.4358",
      "ui-components-test-utils": "static-1.3631",
      "ui-images": "static-2.777",
      "ui-memberships-settings-lib": "static-1.25349",
      "webpack-env": "static-1.41",
      "ai-components-ui-library": "static-1.4164",
      "apollo-stack-hubspot": "static-3.43",
      "atom": "static-1.3350",
      "blueimp-md5": "static-1.8",
      "campaigns-lib": "static-1.19841",
      "classnames": "static-2.10",
      "content-assistance-lib": "static-1.5316",
      "content-management-data-lib": "static-1.3069",
      "copilot-plugins": "static-1.3709",
      "copilot-toolkit": "static-1.3735",
      "cropperjs": "static-1.10",
      "cssUtils": "static-1.325",
      "cta-picker": "static-1.28952",
      "customer-data-objects": "static-1.5594",
      "customer-data-objects-ui-components": "static-1.10832",
      "customer-data-properties": "static-1.42868",
      "customer-data-property-utils": "static-1.5903",
      "customer-data-reference-ui-components": "static-1.10886",
      "customer-data-ui-utilities": "static-1.7640",
      "data-token-picker": "static-1.12777",
      "data-token-views": "static-1.12761",
      "error-messaging-js": "static-1.3301",
      "feedback-loader": "static-1.25245",
      "file-manager-components": "static-1.15963",
      "FileManagerCore": "static-1.31463",
      "FormsCommonComponents": "static-1.78439",
      "foundations-theming": "static-1.2100",
      "fuzzy": "static-1.8",
      "growth-onboarding-confetti": "static-1.1119",
      "growth-payments-core": "static-1.19027",
      "history": "static-4.15",
      "hs-lodash": "static-4.9",
      "hs-promise-utils": "static-1.3476",
      "hub-http-contrib": "static-1.1212",
      "hubspot-url-utils": "static-1.2351",
      "HubStyle": "static-2.9800",
      "icons": "static-2.586",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "InboxConnectUtils": "static-4.8647",
      "integrations-lib": "static-1.8785",
      "interframe": "static-3.2796",
      "laboratory-lib": "static-3.5261",
      "layout-data-lib": "static-1.7054",
      "media-bridge-lib": "static-1.15435",
      "nav-meta": "static-1.24166",
      "object-builder-ui-client": "static-1.38446",
      "onboarding-scopes": "static-1.4566",
      "onboarding-tours": "static-1.12856",
      "onboarding-tours-client": "static-1.2537",
      "outpost": "static-1.2274",
      "PatternValidationJS": "static-1.437",
      "payment-link-components": "static-1.15918",
      "payments-post-enroll-local-storage-lib": "static-1.3071",
      "pictos": "static-7.154",
      "PortalIdParser": "static-2.260",
      "products-ui-components": "static-1.33275",
      "property-translator": "static-1.3421",
      "quick-fetch": "static-1.2224",
      "raven": "static-3.3792",
      "react": "static-7.133",
      "react-beautiful-dnd": "static-1.13",
      "react-colorpicker": "static-2.8206",
      "react-dom": "static-7.85",
      "react-flip-move": "static-1.43",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "react-rhumb": "static-1.14548",
      "react-select-plus": "static-1.65",
      "react-tinymce": "static-1.48207",
      "react-transition-group": "static-1.7",
      "react-virtualized": "static-2.70",
      "redux": "static-4.16",
      "redux-request-state": "static-1.8589",
      "reference-resolvers": "static-1.6129",
      "reference-resolvers-lite": "static-1.5917",
      "reselect": "static-2.16",
      "rich-text-lib": "static-1.16194",
      "sanitize": "static-1.2382",
      "sanitize-text": "static-1.6193",
      "seamless-immutable": "static-7.6",
      "self-service-api": "static-1.8112",
      "SharedI18nStrings": "static-1.160",
      "SharedLegalStrings": "static-1.1255",
      "simple-menus-core": "static-1.12489",
      "simple-menus-lib": "static-1.14007",
      "smart-content-lib": "static-1.35393",
      "styled-components": "static-2.40",
      "StyleGuideUI": "static-3.440",
      "superstore": "static-1.2798",
      "theme-previewer-lib": "static-1.44725",
      "tinymce-config": "static-2.47333",
      "tinymce-copilot": "static-1.9401",
      "tinymce-data": "static-1.33416",
      "tinymce-plugins": "static-1.50447",
      "tinymce-themes": "static-1.49301",
      "transmute": "static-2.29",
      "ui-addon-avatars": "static-2.7414",
      "ui-addon-emoji-picker": "static-1.7917",
      "ui-addon-form-validation": "static-1.9028",
      "ui-addon-i18n": "static-1.8888",
      "ui-addon-iframeable": "static-1.6898",
      "ui-addon-opt": "static-4.6670",
      "ui-addon-sales-email": "static-1.3227",
      "ui-addon-upgrades": "static-9.14913",
      "ui-business-units-lib": "static-1.6791",
      "ui-gdpr-components": "static-1.8241",
      "ui-product-approvals": "static-1.22201",
      "ui-shepherd-react": "static-3.7974",
      "ui-suspension-banners-lib": "static-1.4405",
      "UIComponents": "static-3.6440",
      "underscore": "static-1.8",
      "urlinator": "static-1.2569",
      "usage-tracker": "static-1.5472",
      "usage-tracker-core": "static-1.5322",
      "user-context": "static-1.3136",
      "video-embed": "static-1.27684",
      "web-interactives-components": "static-1.10258",
      "web-interactives-data": "static-1.10259",
      "wootric-nps": "static-1.5032",
      "xray-recommendation-lib": "static-1.4800",
      "codemirror": "static-5.65",
      "react-codemirror": "static-1.8567",
      "enviro": "static-4.282",
      "hs-promise-rejection-tracking": "static-1.3457",
      "raven-hubspot": "static-1.4099",
      "hoist-non-react-statics": "static-3.9",
      "metrics-js": "static-1.7541",
      "bend-plugin-trellis-migration": "static-1.1718",
      "moment": "static-3.26",
      "jquery": "static-3.6",
      "chatspot-client-types": "static-1.7279",
      "chatspot-core": "static-1.12907",
      "chatspot-widget-iframe": "static-1.12904",
      "framework-data-schema-resolvers": "static-1.4692",
      "frontend-preferences-client": "static-1.5859",
      "graphql": "static-1.55",
      "quartz-core": "static-1.3889",
      "cms-field-types": "static-1.2791",
      "content-embed-lib": "static-1.5109",
      "ExportDialog": "static-6.8359",
      "forms-utils-lib": "static-1.8869",
      "integrations-error-boundary-lib": "static-1.6198",
      "payments-embed-points-lib": "static-1.7604",
      "react-dnd-compat": "static-1.2512",
      "usage-tracker-container": "static-1.5462",
      "video-data-lib": "static-1.26841",
      "videoconference-integration-components": "static-1.3929",
      "editor-iframe-lib": "static-1.6265",
      "FireAlarmUi": "static-1.2997",
      "hubspot-apollo-client": "static-1.2832",
      "layout-dnd-components": "static-1.9754",
      "marketing-email-service-types": "static-1.1031",
      "rpc-client-utils": "static-1.2751",
      "smart-content-core": "static-1.34738",
      "social-composer-lib": "static-1.51133",
      "structured-content-lib": "static-1.17509",
      "timezone-utils": "static-2.3284",
      "ui-active-theme-content-creator-lib": "static-1.28732",
      "ui-addon-video-player": "static-1.6716",
      "ui-asset-management-lib": "static-1.7979",
      "ui-tool-access": "static-1.7956",
      "content-icons-ui": "static-1.1827",
      "FileManagerImages": "static-1.29114",
      "hs-story-utils": "static-1.7215",
      "bend-plugin-foundations-components": "static-1.1201",
      "floating-ui": "static-1.23",
      "framer-motion": "static-1.34",
      "react-aria": "static-1.35",
      "tanstack-table": "static-1.10",
      "ui-fonts": "static-1.328",
      "HeadJS": "static-2.528",
      "hs-test-utils-bend-plugin": "static-1.1095",
      "msw": "static-1.39",
      "testing-library": "static-1.116",
      "ts-schema": "static-1.2482",
      "foundations-theming-base": "static-1.1085",
      "i18n-data": "static-1.193",
      "moment-timezone": "static-5.47",
      "NamespacedHubStyle": "static-2.7619",
      "react-dnd-ipeui-backend": "static-1.468",
      "ui-coaching-tips": "static-1.19573",
      "jasmine": "static-4.2366",
      "quartz-core-utils": "static-1.1537",
      "flux-actions": "static-1.257",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.8448",
      "rxjs": "static-5.10",
      "autolinker": "static-3.11",
      "sassPrefix": "static-1.124",
      "campaigns-build-lib": "static-1.4335",
      "crm-pipelines-api-client-types": "static-1.2447",
      "marketing-platform-lib": "static-1.4611",
      "ai-rendering-library": "static-1.2838",
      "ui-brand-identity-lib": "static-1.5406",
      "commerce-products-lib": "static-1.2751",
      "conditional-properties-service-client": "static-1.2293",
      "crm-links": "static-1.4051",
      "crm-message-bus": "static-1.33505",
      "external-options-client-types": "static-1.2436",
      "google-libphonenumber": "static-1.7",
      "inbound-db-properties-service-client": "static-1.2303",
      "inbounddb-objects-service-types": "static-1.2465",
      "pipeline-validation-client-types": "static-1.2223",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.494",
      "forms-ai-lib": "static-1.1242",
      "bend-plugin-foundations-theming": "static-1.583",
      "commerce-analytics-service-client": "static-1.1850",
      "integrations-tracking-lib": "static-1.3357",
      "native-integrations-shared-strings": "static-1.5801",
      "getting-started-shared-tasks": "static-1.8960",
      "growth-data-modal": "static-1.3143",
      "navigation-components": "static-1.12529",
      "ui-shepherd-tracker": "static-1.5355",
      "ui-universal-auth": "static-1.6624",
      "commerce-tours-lib": "static-1.2259",
      "growth-onboarding-reliability": "static-1.3153",
      "sales-checkout-service-client": "static-1.1862",
      "commerce-shared-components-lib": "static-1.12821",
      "commerce-subscription-lib": "static-1.28432",
      "crm_components": "static-3.84157",
      "crm_data": "static-4.84157",
      "customer-data-filters-ui": "static-1.31264",
      "customer-data-tracking": "static-1.4822",
      "dispatcher": "static-1.108",
      "framework-data-table": "static-2.6780",
      "property-description-translator": "static-1.1888",
      "csstype": "static-1.8",
      "fast-json-stable-stringify": "static-1.4",
      "redux-undo": "static-1.10",
      "redux-mock-store": "static-1.8",
      "hubspotter-http": "static-1.2862",
      "feature-store-service-types": "static-1.2796",
      "growth-monetization-service-types": "static-1.2803",
      "upgrade-management-service-types": "static-1.2787",
      "permission-components": "static-1.3363",
      "getting-started-shared-tasks-store": "static-1.8078",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.9",
      "framework-builder-read-service-client": "static-1.2404",
      "framework-data-schema-quick-fetch": "static-1.4597",
      "inbound-db-meta-service-client": "static-1.2094",
      "persist-promise": "static-1.1744",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.596",
      "hubspotter-http-shared-msw-handlers": "static-1.6030",
      "mobile-manifest-mixins": "static-1.299",
      "platform-navigation-bootstrap": "static-1.10112",
      "payments-enrollment-embed-lib": "static-1.15308",
      "apollo-link-hub-http": "static-2.2805",
      "growth-onboarding-feedback-components": "static-1.4450",
      "customer-data-filters": "static-1.45078",
      "highlight.js": "static-1.5",
      "markdown-it": "static-1.6",
      "react-table": "static-1.15",
      "reporting-action-components": "static-1.33578",
      "reporting-ui-components": "static-2.56257",
      "reporting-visualizations": "static-1.51052",
      "ui-addon-teams": "static-1.18628",
      "location-customization-utils-lib": "static-1.1686",
      "final-form": "static-1.36",
      "redux-toolkit": "static-1.7",
      "universal-page-editor-lib": "static-1.852",
      "idb-keyval": "static-1.17",
      "magpie-lib": "static-1.3575",
      "magpie-types": "static-1.3035",
      "simple-logging-lib": "static-1.1075",
      "commerce-billing-lib": "static-1.12441",
      "commerce-contract-lib": "static-1.3114",
      "commerce-tools-ui-lib": "static-1.4306",
      "conversations-skeleton-state": "static-1.5399",
      "crm_universal": "static-1.19670",
      "customer-data-content": "static-1.23052",
      "reporting-data": "static-1.58972",
      "crm_schema": "static-3.84192",
      "customer-data-email": "static-1.14593",
      "customer-data-filters-ui-msw-helpers": "static-1.13696",
      "FormUrlGenerator": "static-2.2740",
      "lodash": "static-4.7",
      "customer-data-associations": "static-1.5183",
      "platform-infra-nav-components": "static-1.5992",
      "marketplace-ui-apps-core": "static-1.10201",
      "stripe-embedded-components": "static-1.4000",
      "deep-diff": "static-1.5",
      "dashboard-lib": "static-1.72889",
      "reporting-snowflake": "static-1.47598",
      "share-with-third-party-component-lib": "static-1.6539",
      "highcharts": "static-8.74",
      "reporting-plugins": "static-1.5182",
      "reporting-reports": "static-1.58661",
      "crm-record-cards-service-types": "static-1.2217",
      "usage-tracker-session-replay": "static-1.2954",
      "crm-cards-sdk": "static-1.35472",
      "customer-data-rte": "static-1.26895",
      "cv-backend-services": "static-1.963",
      "growth-onboarding-empty-states": "static-1.3019",
      "hubspot-prosemirror": "static-1.11512",
      "prosemirror": "static-1.13",
      "qrcode-generator": "static-1.40",
      "SalesContentIndexUI": "static-3.5858",
      "sequences-lib": "static-1.4632",
      "reporting-client-types": "static-1.1453",
      "developer-experience-shared-components": "static-1.7922",
      "immutable-less": "static-1.2585",
      "marketplace-ui-client-types": "static-1.9068",
      "marketplace-ui-common": "static-1.11664",
      "ui-addon-integrations-directory-panel": "static-2.5955",
      "ui-extensibility-client-types": "static-1.2341",
      "stripe-connect-js": "static-1.34",
      "redux-actions": "static-3.7",
      "reporting-datasets-permissions-lib": "static-1.4263",
      "amplitude-session-replay-browser": "static-1.6",
      "crm-actions": "static-1.3946",
      "crm-fe-perf": "static-1.20993",
      "draft-content-plugins": "static-1.22207",
      "draft-convert": "static-2.31",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-plugins": "static-2.17974",
      "trellis-story-utils": "static-1.2533",
      "ui-addon-react-router-dom": "static-1.7594",
      "knowledge-content-types": "static-1.7198",
      "sequences-client-types-lib": "static-1.4488",
      "apps-service-types": "static-1.2492",
      "oauth-service-types": "static-1.2378",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "page-editor-ui": "/page-editor-ui/static-1.29020",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "backbone": "/backbone/static-1.6",
      "codemirror-dlb": "/codemirror-dlb/static-1.50353",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.49356",
      "ContentComponents": "/ContentComponents/static-2.63753",
      "ContentData": "/ContentData/static-1.60871",
      "ContentEditorUI": "/ContentEditorUI/static-2.68801",
      "ContentUtils": "/ContentUtils/static-1.60794",
      "data-fetching-client": "/data-fetching-client/static-1.7421",
      "editor-components": "/editor-components/static-1.10783",
      "emoji-mart": "/emoji-mart/static-3.4",
      "FileManagerLib": "/FileManagerLib/static-1.31605",
      "foundations-assets": "/foundations-assets/static-1.2935",
      "foundations-components": "/foundations-components/static-1.4933",
      "head-dlb": "/head-dlb/static-1.3106",
      "hs-test-utils": "/hs-test-utils/static-1.5984",
      "hub-http": "/hub-http/static-1.4150",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6032",
      "hubspot-dlb": "/hubspot-dlb/static-2.778",
      "HubStyleTokens": "/HubStyleTokens/static-2.9490",
      "I18n": "/I18n/static-7.1324",
      "InpageEditorUI": "/InpageEditorUI/static-1.77247",
      "jasmine-immutable": "/jasmine-immutable/static-1.1029",
      "jasmine-runner": "/jasmine-runner/static-1.4339",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.8729",
      "marketing-discovery-utils": "/marketing-discovery-utils/static-1.1776",
      "quartz": "/quartz/static-1.4670",
      "react-dlb": "/react-dlb/static-1.45",
      "react-dnd": "/react-dnd/static-4.38",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
      "react-redux": "/react-redux/static-7.16",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-utils": "/react-utils/static-2.3657",
      "redux-thunk": "/redux-thunk/static-2.17",
      "settings-ui-lib": "/settings-ui-lib/static-1.10531",
      "sinon": "/sinon/static-1.9",
      "tinymce": "/tinymce/static-6.5",
      "ui-addon-draggable": "/ui-addon-draggable/static-1.4358",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.3631",
      "ui-images": "/ui-images/static-2.777",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.25349",
      "webpack-env": "/webpack-env/static-1.41",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.4164",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "atom": "/atom/static-1.3350",
      "blueimp-md5": "/blueimp-md5/static-1.8",
      "campaigns-lib": "/campaigns-lib/static-1.19841",
      "classnames": "/classnames/static-2.10",
      "content-assistance-lib": "/content-assistance-lib/static-1.5316",
      "content-management-data-lib": "/content-management-data-lib/static-1.3069",
      "copilot-plugins": "/copilot-plugins/static-1.3709",
      "copilot-toolkit": "/copilot-toolkit/static-1.3735",
      "cropperjs": "/cropperjs/static-1.10",
      "cssUtils": "/cssUtils/static-1.325",
      "cta-picker": "/cta-picker/static-1.28952",
      "customer-data-objects": "/customer-data-objects/static-1.5594",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.10832",
      "customer-data-properties": "/customer-data-properties/static-1.42868",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.5903",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.10886",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.7640",
      "data-token-picker": "/data-token-picker/static-1.12777",
      "data-token-views": "/data-token-views/static-1.12761",
      "error-messaging-js": "/error-messaging-js/static-1.3301",
      "feedback-loader": "/feedback-loader/static-1.25245",
      "file-manager-components": "/file-manager-components/static-1.15963",
      "FileManagerCore": "/FileManagerCore/static-1.31463",
      "FormsCommonComponents": "/FormsCommonComponents/static-1.78439",
      "foundations-theming": "/foundations-theming/static-1.2100",
      "fuzzy": "/fuzzy/static-1.8",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1119",
      "growth-payments-core": "/growth-payments-core/static-1.19027",
      "history": "/history/static-4.15",
      "hs-lodash": "/hs-lodash/static-4.9",
      "hs-promise-utils": "/hs-promise-utils/static-1.3476",
      "hub-http-contrib": "/hub-http-contrib/static-1.1212",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.2351",
      "HubStyle": "/HubStyle/static-2.9800",
      "icons": "/icons/static-2.586",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.8647",
      "integrations-lib": "/integrations-lib/static-1.8785",
      "interframe": "/interframe/static-3.2796",
      "laboratory-lib": "/laboratory-lib/static-3.5261",
      "layout-data-lib": "/layout-data-lib/static-1.7054",
      "media-bridge-lib": "/media-bridge-lib/static-1.15435",
      "nav-meta": "/nav-meta/static-1.24166",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.38446",
      "onboarding-scopes": "/onboarding-scopes/static-1.4566",
      "onboarding-tours": "/onboarding-tours/static-1.12856",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.2537",
      "outpost": "/outpost/static-1.2274",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "payment-link-components": "/payment-link-components/static-1.15918",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3071",
      "pictos": "/pictos/static-7.154",
      "PortalIdParser": "/PortalIdParser/static-2.260",
      "products-ui-components": "/products-ui-components/static-1.33275",
      "property-translator": "/property-translator/static-1.3421",
      "quick-fetch": "/quick-fetch/static-1.2224",
      "raven": "/raven/static-3.3792",
      "react": "/react/static-7.133",
      "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
      "react-colorpicker": "/react-colorpicker/static-2.8206",
      "react-dom": "/react-dom/static-7.85",
      "react-flip-move": "/react-flip-move/static-1.43",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-rhumb": "/react-rhumb/static-1.14548",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-tinymce": "/react-tinymce/static-1.48207",
      "react-transition-group": "/react-transition-group/static-1.7",
      "react-virtualized": "/react-virtualized/static-2.70",
      "redux": "/redux/static-4.16",
      "redux-request-state": "/redux-request-state/static-1.8589",
      "reference-resolvers": "/reference-resolvers/static-1.6129",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.5917",
      "reselect": "/reselect/static-2.16",
      "rich-text-lib": "/rich-text-lib/static-1.16194",
      "sanitize": "/sanitize/static-1.2382",
      "sanitize-text": "/sanitize-text/static-1.6193",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "self-service-api": "/self-service-api/static-1.8112",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.160",
      "SharedLegalStrings": "/SharedLegalStrings/static-1.1255",
      "simple-menus-core": "/simple-menus-core/static-1.12489",
      "simple-menus-lib": "/simple-menus-lib/static-1.14007",
      "smart-content-lib": "/smart-content-lib/static-1.35393",
      "styled-components": "/styled-components/static-2.40",
      "StyleGuideUI": "/StyleGuideUI/static-3.440",
      "superstore": "/superstore/static-1.2798",
      "theme-previewer-lib": "/theme-previewer-lib/static-1.44725",
      "tinymce-config": "/tinymce-config/static-2.47333",
      "tinymce-copilot": "/tinymce-copilot/static-1.9401",
      "tinymce-data": "/tinymce-data/static-1.33416",
      "tinymce-plugins": "/tinymce-plugins/static-1.50447",
      "tinymce-themes": "/tinymce-themes/static-1.49301",
      "transmute": "/transmute/static-2.29",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.7414",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.7917",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9028",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.8888",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.6898",
      "ui-addon-opt": "/ui-addon-opt/static-4.6670",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.3227",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.14913",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.6791",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.8241",
      "ui-product-approvals": "/ui-product-approvals/static-1.22201",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.7974",
      "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.4405",
      "UIComponents": "/UIComponents/static-3.6440",
      "underscore": "/underscore/static-1.8",
      "urlinator": "/urlinator/static-1.2569",
      "usage-tracker": "/usage-tracker/static-1.5472",
      "usage-tracker-core": "/usage-tracker-core/static-1.5322",
      "user-context": "/user-context/static-1.3136",
      "video-embed": "/video-embed/static-1.27684",
      "web-interactives-components": "/web-interactives-components/static-1.10258",
      "web-interactives-data": "/web-interactives-data/static-1.10259",
      "wootric-nps": "/wootric-nps/static-1.5032",
      "xray-recommendation-lib": "/xray-recommendation-lib/static-1.4800",
      "codemirror": "/codemirror/static-5.65",
      "react-codemirror": "/react-codemirror/static-1.8567",
      "enviro": "/enviro/static-4.282",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3457",
      "raven-hubspot": "/raven-hubspot/static-1.4099",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "metrics-js": "/metrics-js/static-1.7541",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.1718",
      "moment": "/moment/static-3.26",
      "jquery": "/jquery/static-3.6",
      "chatspot-client-types": "/chatspot-client-types/static-1.7279",
      "chatspot-core": "/chatspot-core/static-1.12907",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.12904",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.4692",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.5859",
      "graphql": "/graphql/static-1.55",
      "quartz-core": "/quartz-core/static-1.3889",
      "cms-field-types": "/cms-field-types/static-1.2791",
      "content-embed-lib": "/content-embed-lib/static-1.5109",
      "ExportDialog": "/ExportDialog/static-6.8359",
      "forms-utils-lib": "/forms-utils-lib/static-1.8869",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.6198",
      "payments-embed-points-lib": "/payments-embed-points-lib/static-1.7604",
      "react-dnd-compat": "/react-dnd-compat/static-1.2512",
      "usage-tracker-container": "/usage-tracker-container/static-1.5462",
      "video-data-lib": "/video-data-lib/static-1.26841",
      "videoconference-integration-components": "/videoconference-integration-components/static-1.3929",
      "editor-iframe-lib": "/editor-iframe-lib/static-1.6265",
      "FireAlarmUi": "/FireAlarmUi/static-1.2997",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.2832",
      "layout-dnd-components": "/layout-dnd-components/static-1.9754",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1031",
      "rpc-client-utils": "/rpc-client-utils/static-1.2751",
      "smart-content-core": "/smart-content-core/static-1.34738",
      "social-composer-lib": "/social-composer-lib/static-1.51133",
      "structured-content-lib": "/structured-content-lib/static-1.17509",
      "timezone-utils": "/timezone-utils/static-2.3284",
      "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.28732",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.6716",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.7979",
      "ui-tool-access": "/ui-tool-access/static-1.7956",
      "content-icons-ui": "/content-icons-ui/static-1.1827",
      "FileManagerImages": "/FileManagerImages/static-1.29114",
      "hs-story-utils": "/hs-story-utils/static-1.7215",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.1201",
      "floating-ui": "/floating-ui/static-1.23",
      "framer-motion": "/framer-motion/static-1.34",
      "react-aria": "/react-aria/static-1.35",
      "tanstack-table": "/tanstack-table/static-1.10",
      "ui-fonts": "/ui-fonts/static-1.328",
      "HeadJS": "/HeadJS/static-2.528",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1095",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.116",
      "ts-schema": "/ts-schema/static-1.2482",
      "foundations-theming-base": "/foundations-theming-base/static-1.1085",
      "i18n-data": "/i18n-data/static-1.193",
      "moment-timezone": "/moment-timezone/static-5.47",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.7619",
      "react-dnd-ipeui-backend": "/react-dnd-ipeui-backend/static-1.468",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.19573",
      "jasmine": "/jasmine/static-4.2366",
      "quartz-core-utils": "/quartz-core-utils/static-1.1537",
      "flux-actions": "/flux-actions/static-1.257",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.8448",
      "rxjs": "/rxjs/static-5.10",
      "autolinker": "/autolinker/static-3.11",
      "sassPrefix": "/sassPrefix/static-1.124",
      "campaigns-build-lib": "/campaigns-build-lib/static-1.4335",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.2447",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.4611",
      "ai-rendering-library": "/ai-rendering-library/static-1.2838",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.5406",
      "commerce-products-lib": "/commerce-products-lib/static-1.2751",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2293",
      "crm-links": "/crm-links/static-1.4051",
      "crm-message-bus": "/crm-message-bus/static-1.33505",
      "external-options-client-types": "/external-options-client-types/static-1.2436",
      "google-libphonenumber": "/google-libphonenumber/static-1.7",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2303",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.2465",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2223",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.494",
      "forms-ai-lib": "/forms-ai-lib/static-1.1242",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.583",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.1850",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.3357",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.5801",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.8960",
      "growth-data-modal": "/growth-data-modal/static-1.3143",
      "navigation-components": "/navigation-components/static-1.12529",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.5355",
      "ui-universal-auth": "/ui-universal-auth/static-1.6624",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.2259",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3153",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.1862",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.12821",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.28432",
      "crm_components": "/crm_components/static-3.84157",
      "crm_data": "/crm_data/static-4.84157",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.31264",
      "customer-data-tracking": "/customer-data-tracking/static-1.4822",
      "dispatcher": "/dispatcher/static-1.108",
      "framework-data-table": "/framework-data-table/static-2.6780",
      "property-description-translator": "/property-description-translator/static-1.1888",
      "csstype": "/csstype/static-1.8",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "redux-undo": "/redux-undo/static-1.10",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "hubspotter-http": "/hubspotter-http/static-1.2862",
      "feature-store-service-types": "/feature-store-service-types/static-1.2796",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.2803",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.2787",
      "permission-components": "/permission-components/static-1.3363",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.8078",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.9",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.2404",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.4597",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2094",
      "persist-promise": "/persist-promise/static-1.1744",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.596",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6030",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.299",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.10112",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.15308",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.2805",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.4450",
      "customer-data-filters": "/customer-data-filters/static-1.45078",
      "highlight.js": "/highlight.js/static-1.5",
      "markdown-it": "/markdown-it/static-1.6",
      "react-table": "/react-table/static-1.15",
      "reporting-action-components": "/reporting-action-components/static-1.33578",
      "reporting-ui-components": "/reporting-ui-components/static-2.56257",
      "reporting-visualizations": "/reporting-visualizations/static-1.51052",
      "ui-addon-teams": "/ui-addon-teams/static-1.18628",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.1686",
      "final-form": "/final-form/static-1.36",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.852",
      "idb-keyval": "/idb-keyval/static-1.17",
      "magpie-lib": "/magpie-lib/static-1.3575",
      "magpie-types": "/magpie-types/static-1.3035",
      "simple-logging-lib": "/simple-logging-lib/static-1.1075",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.12441",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.3114",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.4306",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.5399",
      "crm_universal": "/crm_universal/static-1.19670",
      "customer-data-content": "/customer-data-content/static-1.23052",
      "reporting-data": "/reporting-data/static-1.58972",
      "crm_schema": "/crm_schema/static-3.84192",
      "customer-data-email": "/customer-data-email/static-1.14593",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.13696",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.2740",
      "lodash": "/lodash/static-4.7",
      "customer-data-associations": "/customer-data-associations/static-1.5183",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.5992",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.10201",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.4000",
      "deep-diff": "/deep-diff/static-1.5",
      "dashboard-lib": "/dashboard-lib/static-1.72889",
      "reporting-snowflake": "/reporting-snowflake/static-1.47598",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.6539",
      "highcharts": "/highcharts/static-8.74",
      "reporting-plugins": "/reporting-plugins/static-1.5182",
      "reporting-reports": "/reporting-reports/static-1.58661",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2217",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.2954",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.35472",
      "customer-data-rte": "/customer-data-rte/static-1.26895",
      "cv-backend-services": "/cv-backend-services/static-1.963",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.3019",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.11512",
      "prosemirror": "/prosemirror/static-1.13",
      "qrcode-generator": "/qrcode-generator/static-1.40",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.5858",
      "sequences-lib": "/sequences-lib/static-1.4632",
      "reporting-client-types": "/reporting-client-types/static-1.1453",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.7922",
      "immutable-less": "/immutable-less/static-1.2585",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.9068",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.11664",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.5955",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2341",
      "stripe-connect-js": "/stripe-connect-js/static-1.34",
      "redux-actions": "/redux-actions/static-3.7",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.4263",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.6",
      "crm-actions": "/crm-actions/static-1.3946",
      "crm-fe-perf": "/crm-fe-perf/static-1.20993",
      "draft-content-plugins": "/draft-content-plugins/static-1.22207",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-plugins": "/draft-plugins/static-2.17974",
      "trellis-story-utils": "/trellis-story-utils/static-1.2533",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.7594",
      "knowledge-content-types": "/knowledge-content-types/static-1.7198",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.4488",
      "apps-service-types": "/apps-service-types/static-1.2492",
      "oauth-service-types": "/oauth-service-types/static-1.2378",
      "react-window": "/react-window/static-1.13"
    },
    "project": "page-editor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};